export function parse() {
  let search = window.location.search;
  let params = search.substr(1).split('&');
  let qs = {};
  params.forEach(param => {
    let list = param.split('=');
    if (list.length > 1) {
      qs[list[0]] = list[1];
    }
  });
  return qs;
}